
import { Vue } from "vue-class-component";

export default class HomeView extends Vue {}
